<template>
  <main class="container p-4 pt-2 text-sp-primary">
    <Search />
    <section class="container p-0 my-8 mt-0 text-sp-primary">
      <div v-if="loading" class="fade"><Loading /></div>
      <div v-else-if="error">{{ $t("error") }}</div>
      <div v-else>
        <div class="flex justify-center">
          <h1 class="heading inline-block text-2xl text-sp-accent text-center font-bold">
            {{ sectionName }}
          </h1>
        </div>
        <div class="category-list grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-14 mt-6">
          <RouterLink
            v-for="(article, index) in articles"
            :key="article.id"
            :to="`/category/${categoryId}/section/${sectionId}/article/${article.id}`"
            @click="logClick(`section.${categoryId}/${sectionId}/${article.id}`, 'section.sectionsDetails')"
            class="flex items-center gap-3 p-4 px-0 hover:text-sp-accent duration-150 ease-in-out"
          >
            <img :src="article.promoted ? magentaIcon : yellowIcon" alt="dot icon" class="w-3 h-3" />
            <p class="leading-tight line-clamp-1">{{ article.name || "Untitled article" }}</p>
            <img src="../assets/icon-arrow.png" alt="arrow icon" class="w-3 ml-auto" />
          </RouterLink>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { onMounted, computed } from "vue"
import { useRoute } from 'vue-router'
import { getUserData } from '../modules/collectData.js'
import { useLogger } from '../composables/useLogger'
import { useHelpCenterFetch } from '../composables/useHelpCenterFetch'
import { useHelpCenterStore } from '../stores/helpCenter'
import Search from '../components/Search.vue'
import Loading from '../components/Loading.vue'
import yellowIcon from '../assets/icon-dot-yellow.png'
import magentaIcon from '../assets/icon-dot-magenta.png'

export default {
  components: {
    Search,
    Loading
  },
  setup() {
    const { lang } = getUserData()
    const { logClick } = useLogger()
    const route = useRoute()
    const helpCenter = useHelpCenterStore()

    const categoryId = computed(() => route.params.categoryId)
    const sectionId = computed(() => route.params.sectionId)

    const { data, loading, error, load } = useHelpCenterFetch(
      () => `helpcenter/${lang}/sections/${route.params.sectionId}`,
      {
        select: (answer) => {
          if (!Array.isArray(answer?.articles)) {
            throw new Error('expected articles array')
          }
          return {
            title: answer.title,
            categoryName: answer.categoryName,
            articles: answer.articles.map(item => ({
              name: item.title || 'Untitled article',
              id: item.id || 'No id available',
              promoted: item.promoted === true
            }))
          }
        }
      }
    )

    const articles = computed(() => data.value?.articles || [])
    const sectionName = computed(() => data.value?.title || null)
    const categoryName = computed(() => data.value?.categoryName || null)

    onMounted(async () => {
      await load()
      if (!data.value) return

      if (data.value.title) {
        helpCenter.setCurrentSection({
          id: sectionId.value,
          name: data.value.title,
        })
      }

      if (data.value.categoryName) {
        helpCenter.setCurrentCategory({
          id: categoryId.value,
          name: data.value.categoryName,
        })
      }
    })

    return {
      articles,
      loading,
      error,
      categoryId,
      sectionName,
      categoryName,
      sectionId,
      yellowIcon,
      magentaIcon,
      logClick
    }
  }
}
</script>